module.exports = __webpack_public_path__ + "img/logo.cdc44c2f.png";